import axios from 'axios'

export default {
  // 보험신청 API
  applyInsurance (data, cb) {
    axios.post('/biz/maintenance/insurance/', data)
      .then(function (response) {
        // 정상적으로 데이터 전송한 경우에는
        if (response.status === 201) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('can`t apply insurance!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 비즈케어 신청 API
  applyBizcare (data, cb) {
    axios.post('/biz/bizcare/', data)
      .then(function (response) {
        // 정상적으로 데이터 전송한 경우에는
        if (response.status === 201) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('can`t apply bizcare!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  // 전력중개사업 API
  applyVpp (data, cb) {
    axios.post('/biz/vpp/', data)
      .then(function (response) {
        // 정상적으로 데이터 전송한 경우에는
        if (response.status === 201) {
          if (response.data.error) {
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          console.log('can`t apply vpp!')
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  },

  getPlantsCount (cb) {
    axios.get('/biz/index/plants_count/')
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.error) {
            response.error = true
            cb(response.data)
          } else {
            cb(response.data)
          }
        } else {
          response.error = true
          cb(response)
        }
      })
      .catch(function (response) {
        response.error = true
        cb(response)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/onm.js